export type ListenerType<T> = (value: T, prev: T) => void;

export function readonly<T>(value: T): Readonly<T> {
  if (typeof value === 'object') {
    return Object.freeze(value);
  } else {
    return value;
  }
}
